<div>
  <h2>{{'usuarios.productor.titulo' | translate}}</h2>
  <section class="filters-framed" *ngIf="filtersVisible">
    <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
      <h3>{{'usuarios.productor.filters.filtrosDenominacion' | translate}}</h3>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.pais' | translate}}</label>
        <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'usuarios.productor.filters.denominacion' | translate}}</label>
        <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
          [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.finca' | translate}}</label>
        <input type="text" formControlName="finca">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'usuarios.productor.filters.licencia' | translate}}</label>
        <input type="text" formControlName="licencia">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
      <div *ngIf="this.isSmallScreen" class="entry-3-small"></div>
      <h3>{{'usuarios.productor.filters.filtrosPersonales' | translate}}</h3>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.pais' | translate}}</label>
        <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('paisProductor')" [placeHolder]="false">
        </app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.provincia' | translate}}</label>
        <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
          [disabled]="disabledProvincia" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'global.municipio' | translate}}</label>
        <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
          [disabled]="disabledMunicipio" [placeHolder]="false"></app-filterable-list>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.inicio' | translate}}</label>
        <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
          (click)="fechaInicio.open()">
        <mat-datepicker #fechaInicio></mat-datepicker>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
        <label>{{'global.fecha.fin' | translate}}</label>
        <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
        <mat-datepicker #fechaFin></mat-datepicker>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left">
        <input type="radio" id="insercion" value="false" formControlName="dateType">
        <label for="insercion">{{'global.fecha.insercion' | translate}}</label>
        <input type="radio" id="actualizacion" value="true" formControlName="dateType">
        <label for="actualizacion">{{'global.fecha.actualizacion' | translate}}</label>
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
        <label>{{'usuarios.productor.filters.productor' | translate}}</label>
        <input type="text" formControlName="productor">
      </div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
      <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'"></div>
      <div *ngIf="!this.isSmallScreen" class="entry-5"></div>
    </form>
  </section>
  <section class="filters-buttons">
    <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
      title="{{'global.filtros.abrir' | translate}}">
      <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
      (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
      <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
    </button>
    <button *ngIf="filtersVisible" class="secondary"
      [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
      title="{{'global.filtros.limpiar' | translate}}">
      <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
    </button>
    <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
      title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
      <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
    </button>
  </section>
  <section class="export-buttons">
    <!-- Icono importación CSV. svg para aplicar tema custom -->
    <svg 
      *ngIf="this.role !== 'Administrador' && !this.claims.includes('D_PRO')" class="csv-upload disabled" 
      [attr.title]="'titles.importarCSV' | translate"
      xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 384 512">
        <path d="M177.5,115.9v94.9c0,13.1,10.8,23.7,24.1,23.7h96.3v213.4c0,26.2-21.6,47.4-48.2,47.4H57.2c-26.6,0-48.2-21.3-48.2-47.4V163.3c0-26.2,21.6-47.4,48.2-47.4h120.4ZM69.2,281.9c-16.6,0-30.1,13.3-30.1,29.6v59.3c0,16.4,13.5,29.6,30.1,29.6h12c16.6,0,30.1-13.3,30.1-29.6v-5.9c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v5.9c0,3.3-2.7,5.9-6,5.9h-12c-3.3,0-6-2.7-6-5.9v-59.3c0-3.3,2.7-5.9,6-5.9h12c3.3,0,6,2.7,6,5.9v5.9c0,6.5,5.4,11.9,12,11.9s12-5.3,12-11.9v-5.9c0-16.4-13.5-29.6-30.1-29.6h-12ZM141,346.1l19.1,10.7c3.3,1.9,5.4,5.5,5.4,9.3,0,5.9-4.8,10.7-10.8,10.7h-19.3c-6.6,0-12,5.3-12,11.9s5.4,11.9,12,11.9h19.3c19.3,0,34.9-15.4,34.9-34.4s-6.7-23.7-17.6-29.8l-19.1-10.7c-3.3-1.9-5.4-5.5-5.4-9.3,0-5.9,4.8-10.7,10.8-10.7h13.2c6.6,0,12-5.3,12-11.9s-5.4-11.9-12-11.9h-13.2c-19.3,0-34.9,15.4-34.9,34.4s6.7,23.7,17.6,29.8ZM219.7,293.8c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,25.7,7.7,50.9,22.3,72.3l3.8,5.7c2.3,3.3,5.9,5.3,10,5.3s7.7-2,10-5.3l3.8-5.7c14.5-21.4,22.3-46.6,22.3-72.3v-23.4c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,17-4.1,33.8-12,48.8-7.9-15-12-31.8-12-48.8v-23.4ZM201.6,115.9l96.3,94.9h-96.3v-94.9Z"/>
        <path d="M374.6,104.8l-47.9-53.9-47.9,53.9c-.9,1.1,0,2.7,1.3,2.7h26.1v73.4c0,5.4,4.4,9.8,9.8,9.8h21.2c5.4,0,9.8-4.4,9.8-9.8v-73.4h26.1c1.4,0,2.2-1.6,1.3-2.7Z"/>
    </svg>
    <svg 
      *ngIf="this.role === 'Administrador' || this.claims.includes('D_PRO')" class="csv-upload" 
      [attr.title]="'titles.importarCSV' | translate" (click)="showCsvImportModal()"
      xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 384 512">
        <path d="M177.5,115.9v94.9c0,13.1,10.8,23.7,24.1,23.7h96.3v213.4c0,26.2-21.6,47.4-48.2,47.4H57.2c-26.6,0-48.2-21.3-48.2-47.4V163.3c0-26.2,21.6-47.4,48.2-47.4h120.4ZM69.2,281.9c-16.6,0-30.1,13.3-30.1,29.6v59.3c0,16.4,13.5,29.6,30.1,29.6h12c16.6,0,30.1-13.3,30.1-29.6v-5.9c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v5.9c0,3.3-2.7,5.9-6,5.9h-12c-3.3,0-6-2.7-6-5.9v-59.3c0-3.3,2.7-5.9,6-5.9h12c3.3,0,6,2.7,6,5.9v5.9c0,6.5,5.4,11.9,12,11.9s12-5.3,12-11.9v-5.9c0-16.4-13.5-29.6-30.1-29.6h-12ZM141,346.1l19.1,10.7c3.3,1.9,5.4,5.5,5.4,9.3,0,5.9-4.8,10.7-10.8,10.7h-19.3c-6.6,0-12,5.3-12,11.9s5.4,11.9,12,11.9h19.3c19.3,0,34.9-15.4,34.9-34.4s-6.7-23.7-17.6-29.8l-19.1-10.7c-3.3-1.9-5.4-5.5-5.4-9.3,0-5.9,4.8-10.7,10.8-10.7h13.2c6.6,0,12-5.3,12-11.9s-5.4-11.9-12-11.9h-13.2c-19.3,0-34.9,15.4-34.9,34.4s6.7,23.7,17.6,29.8ZM219.7,293.8c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,25.7,7.7,50.9,22.3,72.3l3.8,5.7c2.3,3.3,5.9,5.3,10,5.3s7.7-2,10-5.3l3.8-5.7c14.5-21.4,22.3-46.6,22.3-72.3v-23.4c0-6.5-5.4-11.9-12-11.9s-12,5.3-12,11.9v23.4c0,17-4.1,33.8-12,48.8-7.9-15-12-31.8-12-48.8v-23.4ZM201.6,115.9l96.3,94.9h-96.3v-94.9Z"/>
        <path d="M374.6,104.8l-47.9-53.9-47.9,53.9c-.9,1.1,0,2.7,1.3,2.7h26.1v73.4c0,5.4,4.4,9.8,9.8,9.8h21.2c5.4,0,9.8-4.4,9.8-9.8v-73.4h26.1c1.4,0,2.2-1.6,1.3-2.7Z"/>
    </svg>
    <i 
      class="fas fa-file-pdf"
      [ngClass]="{'disabled': !productoresList || (productoresList && productoresList.length === 0)}"
      title="{{'titles.exportarPDF' | translate}}"
      (click)="showExportModal('pdf')"></i>
    <i class="fas fa-file-csv" [ngClass]="{'disabled': !productoresList || (productoresList && productoresList.length === 0)}"
      (click)="showExportModal('csv')" title="{{'titles.exportarCSV' | translate}}"></i>
    <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
  </section>
  <div class="table-wrapper m-bottom">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th class="icon"></th>
            <th class="id sortable" (click)="toOrderBy('x=> x.id', 2)">
              {{'usuarios.productor.table.id' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('x=> x.id', 2)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.Municipio.Provincia.Pais.DesPaisDefecto', 3)">
              {{'global.pais' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('x=> x.Municipio.Provincia.Pais.DesPaisDefecto', 3)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.Municipio.Provincia.Des', 4)">
              {{'global.provincia' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('x=> x.Municipio.Provincia.Des', 4)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.Municipio.Des', 5)">
              {{'global.municipio' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('x=> x.Municipio.Des', 5)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.des', 6)">
              {{'usuarios.productor.table.productor' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('x=> x.des', 6)"></i>
              </div>
            </th>
            <th class="string sortable" *ngIf="this.role !== 'Auditor'" (click)="toOrderBy('x=> x.nifcif', 7)">
              {{'usuarios.productor.table.nif' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('x=> x.nifcif', 7)"></i>
              </div>
            </th>
            <th class="string sortable" (click)="toOrderBy('x=> x.personaContacto', 8)">
              {{'usuarios.productor.table.contacto' | translate}}
              <div class="sortable-icons">
                <i [ngClass]="getIcon('x=> x.personaContacto', 8)"></i>
              </div>
            </th>
            <th class="action">
              <i class="fas fa-plus" 	*ngIf="this.role === 'Administrador' || this.claims.includes('PROD_Ins')"
                  (click)="create()" title="{{'usuarios.productor.tituloNew' | translate}}"></i>
            </th>
          </tr>
        </thead>
        <tbody class="clickable" [ngClass]="{'clickable': getRolePermission()}" *ngFor="let productor of productoresList; let i=index; trackBy: trackByProductorId">
          <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
            <td class="icon"><i *ngIf="this.role !== 'Auditor'" [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
            </td>
            <td class="id">{{productor.id}}</td>
            <td class="string">{{productor.desPais}}</td>
            <td class="string">{{productor.desProvincia}}</td>
            <td class="string">{{productor.desMunicipio}}</td>
            <td class="string">{{productor.des}}</td>
            <td class="string" *ngIf="this.role !== 'Auditor'">{{productor.nifcif}}</td>
            <td class="string">{{productor.personaContacto}}</td>
            <td class="multi-actions">
              <i class="fas fa-stream" app-click-stop-propagation (click)="showSection(i)"
                 title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
              <i class="fas fa-pencil-alt" 	*ngIf="this.role === 'Administrador' || this.claims.includes('PROD_Upd')"
                  app-click-stop-propagation (click)="update(productor)" title="{{'titles.editar' | translate}}"></i>
              <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}"
                 *ngIf="this.role === 'Administrador' || this.claims.includes('PROD_Del')"
                 [ngClass]="{'disabled': (productor.registroEnUso)}" app-click-stop-propagation
                (click)="askDelete(productor)"></i>
            </td>
          </tr>
          <tr *ngIf="dropdownInfo === i">
            <td colspan="9">
              <div class="detail">
                <div class="title">{{'global.masInformacion' | translate}}</div>
                <div class="block-inline">
                  <label>{{'global.fecha.insercionShort' | translate}}</label>
                  <p>
                    {{productor.fechaIns ? (productor.fechaIns | date: 'dd/MM/yyyy') : 'Sin fecha'}}
                  </p>
                </div>
                <div class="block-inline">
                  <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                  <p>
                    {{productor.fechaUpd ? (productor.fechaUpd | date: 'dd/MM/yyyy') : 'Sin fecha'}}
                  </p>
                </div>
                <div class="block-inline">
                  <label>{{'usuarios.productor.table.usuario' | translate}}</label>
                  <p>
                    {{productor.userName ? productor.userName : 'Sin usuario'}}
                  </p>
                </div>
                <div class="block-inline">
                  <label>{{'usuarios.productor.table.telefono' | translate}}</label>
                  <p>
                    {{productor.phoneNumber}}
                  </p>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="dropdownSection === i">
            <td colspan="11">
              <section class="tabs">
                <ul>
                  <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showHuertos(i)">
                    {{'global.cultivos' | translate}}</li>
                  <li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showDenominaciones(i)">
                    {{'usuarios.productor.table.tabs.denominaciones.titulo' | translate}}</li>
                </ul>
                <content>
                  <app-pro-huertos *ngIf="pestanaActiva[i] === 1" [productorId]="productor.id">
                  </app-pro-huertos>
                  <app-pro-denominaciones *ngIf="pestanaActiva[i] === 2" [productorId]="productor.id" (pushMessage)="pushMessage($event)" (refresh_)="refresh($event)">
                  </app-pro-denominaciones>
                </content>
              </section>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="!productoresList || (productoresList && productoresList.length < 1)">
          <tr>
            <td colspan="11">
              {{'global.noContent' | translate}}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
  <app-paginator *ngIf="productoresList && productoresList.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
  <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event">
  </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
  <div class="modal-content">
    <header>
      <h4>{{'global.eliminar.descripcion' | translate}}</h4>
    </header>
    <content>
      <p>{{'global.eliminar.confirmacion' | translate}}</p>
    </content>
    <footer>
      <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
      <button (click)="delete()">{{'global.confirmar' | translate}}</button>
    </footer>
  </div>
</div>
<div class="modal" *ngIf="newEditModal">
  <div class="modal-content">
    <header>
      <h4>{{productorId ? ('usuarios.productor.tituloEdit' | translate) : ('usuarios.productor.tituloNew' | translate)}}
      </h4>
    </header>
    <app-pro-new-edit [productorId]="productorId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
    </app-pro-new-edit>
  </div>
</div>
<div class="modal" *ngIf="exportModal">
  <div class="modal-content">
    <header>
      <h4>{{ 'usuarios.productor.modalInformes.titulo' | translate }} {{ exportFormat === 'pdf' ? 'PDF' : 'CSV'}}</h4>
      <i class="fas fa-times" (click)="exportModal = false"></i>
    </header>
    <content>
      <button (click)="exportPdfOrCsv('general')">{{ 'usuarios.productor.modalInformes.general' | translate }}</button>
      <button (click)="exportPdfOrCsv('detailed')">{{ 'usuarios.productor.modalInformes.detallado' | translate }}</button>
    </content>
  </div>
</div>

<div class="modal" *ngIf="csvImportModal">
  <div class="modal-content csv" [ngClass]="getCsvModalClass()">
    <header>
      <h4>{{ 'csv-import.title' | translate }}</h4>
    </header>
    <content class="content">
      <app-csv-import [mainKeyword]="'producers'" (csvStep)="csvStep = $event" (openFormOrRefreshAfterClose)="hideCsvModal($event)"></app-csv-import>
    </content>
  </div>
</div>